export const environment = {
  production: false,
  pendoEnabled: true,
  batchSdnCalls: process.env['NX_PUBLIC_BATCH_SDN_CALLS'] !== '0',
  appVersion: process.env['NX_PUBLIC_APP_VERSION'],
  appEnv: process.env['NX_PUBLIC_APP_ENV'],
  spinsIntelligenceSfID: 'a56TR000000ESPRYA4',
  powerTabsSfID: 'a56Dm000000XxtPIAS',
  agentforceOrgId: '00D36000000Ja3N',
  agentforceDeploymentName: 'SPINS_Portal_Get_Help',
  agentforceSiteUrl: 'https://spins.my.site.com/ESWSPINSPortalAskaQue1791403067458',
  agentforceScrt2Url: 'https://spins.my.salesforce-scrt.com',
  reportIssueSiteUrl: 'https://spins--uat.sandbox.my.salesforce-sites.com',
  reportIssueFlowApiName: 'Create_Test_Case_External',
  panelDataIframeUrl:
    'https://spinsllc.auth0.com/samlp/sT8Wtkhc67OUzaSvrzuHGFtHaS1fXqQH',
  attlabSfid: ['a56Dm000000LI27IAG', 'a56Dm000000LI2IIAW'],
  destiniAppsSfids: [
    'a56Dm000000LI1zIAG',
    'a56Dm000000LI2FIAW',
    'a56Dm000000LI2JIAW',
    'a56Dm000000LI2SIAW',
    'a56Dm000000LI2EIAW',
    'a56Dm000000LI2UIAW',
    'a56TH000000B7NxYAK',
  ],
  productHubSfID: 'a56Dm000000XxtOIAS',
  authBaseUrl: 'https://dev.auth.spins.team',
  remoteRetailInsightsUrl: 'https://uat.retail-platform.spins.team',
  remoteBrandInsightsUrl: 'https://uat.brand-insights.spins.team',
  remoteProductHubUrl: 'https://uat.ris-product-hub.spins.team',
  remoteIgnitePlusUrl: 'https://uat.ignite-plus.spins.team',
  remotePartnerInsightsUrl: 'https://spins-partner-insights-uat.uc.r.appspot.com/',
  remotePowerTabsUrl: 'https://uat.powertabs.spins.team/',
  remoteKeyAccountApprovalsUrl: 'https://uat.key-account-approvals.spins.team',
  remoteFoundry: 'https://storage.googleapis.com/spins-foundry-dev-public-html-host/foundry-ui/',
  remoteTryFoundry: 'https://storage.googleapis.com/spins-foundry-dev-public-html-host/foundry-ui/',
  remoteInsightsBuilder:
    'https://storage.googleapis.com/spins-agentic-efficiency-uat-public-html-host/client-insights-ui/',
  remoteTraderoiUrl: 'https://uat.traderoi.spins.team/',
  remoteExtractsUrl: 'https://storage.googleapis.com/spins-extracts-uat-public-html-host/',
  onMaintenance: false,
  allowedCompanyTypesDefaultFilters: ['RETAILER'],
  ignitePlusSfID: ['a56TR0000006bGDYAY', 'a56VE000000Z8vZYAS'],
  itemAttributeCodingSfID: 'a56TH0000009j2jYAA',
  disablePowerBiNavigationPane: ['a56Dm000000XxtPIAS', 'a56TH000000AXHFYA4'],
  whizAiUrl: 'https://spins-uat.whiz.ai/',
  whizAiAudience: 'https://spins-uat.whiz.ai/',
  auth0Domain: 'spinsllc.auth0.com',
};
